import axios from "axios";
import { API } from "@/lib/api";
import { BOOKING_URL } from "@/config";

const VKEY = "mpp_visitor_id";
const SKEY = "mpp_session_id";

const uuid = () =>
  window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

export function getVisitorId() {
  let v = localStorage.getItem(VKEY);
  if (!v) { v = uuid(); localStorage.setItem(VKEY, v); }
  return v;
}

function ensureSession() {
  let s = sessionStorage.getItem(SKEY);
  const isNew = !s;
  if (!s) { s = uuid(); sessionStorage.setItem(SKEY, s); }
  return { s, isNew };
}

export const isAdvisor = () => !!localStorage.getItem("mpp_token");
const trackable = () => !isAdvisor() && !window.location.pathname.startsWith("/admin");

export function track(type, opts = {}) {
  try {
    if (!trackable()) return;
    const { s } = ensureSession();
    const body = {
      visitor_id: getVisitorId(),
      session_id: s,
      type,
      path: opts.path ?? window.location.pathname,
      label: opts.label ?? null,
      meta: opts.meta ?? null,
      time_ms: opts.time_ms ?? 0,
      is_new_session: opts.is_new_session ?? false,
    };
    const url = `${API}/track`;
    if (opts.beacon && navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([JSON.stringify(body)], { type: "application/json" }));
    } else {
      axios.post(url, body).catch(() => {});
    }
  } catch (e) { /* silent */ }
}

export function startSession() {
  if (!trackable()) return;
  const { isNew } = ensureSession();
  if (isNew) track("session", { is_new_session: true });
}

export const BOOKING_HOST = (() => {
  try { return new URL(BOOKING_URL).host; } catch { return "outlook.office.com"; }
})();
